import React from 'react';
import './Navbar.css'

export default function Navbar() {
  return (
    <div className="nav-rapper">
      <div className="netlogo-container">
        <div className="netlogo" style={{ zIndex: 23 }}>
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 1121.7 1365.1"
            xmlSpace="preserve"
          >
            <style type="text/css">
              {`.st0{fill:#FFFFFF;}`}
            </style>
            <g>
              <g>
                <path className="st0" d="M950.8,549.5C950.8,549.4,950.8,549.4,950.8,549.5L1.4,0.9H1.1v327c0,76.1,41.7,142.3,103.4,177.5
			c0,0,0,0.1-0.1,0.1l949.4,548.5h0.3V727C1054.1,650.8,1012.5,584.6,950.8,549.5z"/>
                <g>
                  <path className="st0" d="M103.1,725.8L103.1,725.8C47.7,694.1,8.5,637.3,1.2,570.9v482.9l334.9-193.3L103.1,725.8z" />
                </g>
                <g>
                  <path className="st0" d="M952.3,329C952.3,329,952.3,329.1,952.3,329c55.4,31.7,94.6,88.5,101.9,154.9V1.1L719.4,194.4L952.3,329z" />
                </g>
              </g>
              <path className="st0" d="M241.6,1274.8h92.6v-32.6h-92.6v-41h100.9v-35.3h-143V1357h145.1v-35.3h-103V1274.8z M358.1,1201.2h57.3V1357
		h42v-155.8h57.3v-35.3H358.1V1201.2z M123.2,1294.1h-0.5l-79.8-128.2H1.1V1357h39.3v-128h0.5l79.5,128h42v-191.1H123v128.2H123.2z
		 M796.1,1161.3c-59.2,0-94,44.2-94,100.9c0,55.2,34.8,99.3,94,99.3s94-44.2,94-99.3C890.1,1205.5,855.3,1161.3,796.1,1161.3z
		 M796.1,1326.2c-37.8,0-51.9-32.1-51.9-64c0-33.5,14.2-65.6,51.9-65.6s51.9,32.1,51.9,65.6C848.1,1294.1,833.9,1326.2,796.1,1326.2
		z M628.8,1244.6c-47.9-12.3-57-14.2-57-28.9c0-16.1,15.5-21.7,28.9-21.7c20.1,0,36.4,5.9,37.7,28.9h40.7
		c0-44.2-36.7-61.6-76.6-61.6c-34.5,0-71.5,18.7-71.5,57.8c0,35.9,28.6,46.9,57,54.3c28.1,7.5,56.8,11,56.8,31.6
		c0,19.6-22.5,23.8-37.2,23.8c-22.5,0-42.3-9.9-42.3-35.3h-40.7c-0.5,47.1,39.1,68,81.4,68c51.9,0,79.5-26.2,79.5-61.3
		C685.5,1256.9,642.7,1248,628.8,1244.6z M960.8,1165.9h-42V1357H1054v-35.3h-93.2V1165.9z"/>
              <g>
                <path className="st0" d="M1118.5,1334.6c0,12.6-9.9,22.5-22.7,22.5c-12.7,0-22.9-9.9-22.9-22.5c0-12.3,10.1-22.2,22.9-22.2
			C1108.6,1312.4,1118.5,1322.3,1118.5,1334.6z M1078.6,1334.6c0,9.9,7.3,17.7,17.3,17.7c9.7,0,16.9-7.8,16.9-17.6
			c0-9.9-7.2-17.9-17-17.9C1085.9,1316.9,1078.6,1324.8,1078.6,1334.6z M1092.2,1346.2h-5.1V1324c2-0.4,4.9-0.7,8.5-0.7
			c4.2,0,6.1,0.7,7.7,1.6c1.2,0.9,2.2,2.7,2.2,4.9c0,2.4-1.9,4.3-4.6,5.1v0.3c2.2,0.8,3.4,2.4,4.1,5.4c0.7,3.4,1.1,4.7,1.6,5.5h-5.5
			c-0.7-0.8-1.1-2.8-1.8-5.4c-0.4-2.4-1.8-3.5-4.6-3.5h-2.4L1092.2,1346.2L1092.2,1346.2z M1092.4,1333.6h2.4c2.8,0,5.1-0.9,5.1-3.2
			c0-2-1.5-3.4-4.7-3.4c-1.4,0-2.3,0.1-2.8,0.3V1333.6z"/>
              </g>
            </g>
          </svg>
        </div>
      </div>
      <div className="select">
        <select className='opt'>
          <option>English</option>
          <option>اردو</option>
          <option>German</option>
          <option>Thai</option>
        </select>
      </div>
    </div>
  );
}
